import { render, staticRenderFns } from "./AppDraggableAndResizableWrapper.vue?vue&type=template&id=5bd43b70"
import script from "./AppDraggableAndResizableWrapper.vue?vue&type=script&lang=ts"
export * from "./AppDraggableAndResizableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AppDraggableAndResizableWrapper.vue?vue&type=style&index=0&id=5bd43b70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports